export default __webpack_public_path__ + "static/media/productImage.fb238701.png";